
import { Link } from "react-router-dom"

const LegalDocumentCard = ({ document, onDelete }) => {
  const getCategoryBadgeClass = (category) => {
    const badgeClasses = {
      terms_conditions: "bg-primary",
      privacy_policy: "bg-info",
      disclaimer: "bg-warning",
      ip_management: "bg-danger",
      cookie_policy: "bg-secondary",
      refund_policy: "bg-success",
      community_guidelines: "bg-dark",
      seller_agreement: "bg-purple",
      buyer_agreement: "bg-orange",
      api_terms: "bg-teal",
    }
    return badgeClasses[category] || "bg-secondary"
  }

  const formatCategoryName = (category) => {
    return category.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  const getTypeIcon = (type) => {
    const icons = {
      rich_text: "fas fa-edit",
      markdown: "fab fa-markdown",
      html: "fas fa-code",
      static: "fas fa-file-alt",
      custom_upload: "fas fa-file-upload",
    }
    return icons[type] || "fas fa-file"
  }

  return (
    <div className="card h-100 legal-document-card">
      <div className="card-header d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <span className={`badge ${getCategoryBadgeClass(document.category)} mb-2`}>
            {formatCategoryName(document.category)}
          </span>
          <h6 className="card-title mb-1">{document.title}</h6>
          <small className="text-muted">
            <i className={`${getTypeIcon(document.type)} me-1`}></i>
            {document.type.replace(/_/g, " ")}
          </small>
        </div>
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary dropdown-toggle"
            type="button"
            id={`dropdown-${document._id}`}
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Actions
          </button>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={`dropdown-${document._id}`}>
            <li>
              <Link className="dropdown-item" to={`/admin/legal-documents/view/${document._id}`}>
                View
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to={`/admin/legal-documents/edit/${document._id}`}>
                Edit
              </Link>
            </li>
            {/* <li>
              <Link className="dropdown-item" to={`/admin/legal-documents/versions/${document._id}`}>
                <i className="fas fa-history me-2"></i>Versions
              </Link>
            </li> */}
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <button
                className="dropdown-item text-danger"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  onDelete(document._id)
                  // Close dropdown after action
                  const dropdownMenu = e.target.closest(".dropdown-menu")
                  if (dropdownMenu) {
                    dropdownMenu.classList.remove("show")
                  }
                }}
              >
                Deactivate
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="card-body">
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">Status</span>
            <span className={`badge ${document.isActive ? "bg-success" : "bg-secondary"}`}>
              {document.isActive ? "Active" : "Inactive"}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">Version</span>
            <span className="fw-bold">{document.version}</span>
          </div>

          {document.requiresAgreement && (
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-muted small">Requires Agreement</span>
              <i className="fas fa-check-circle text-success"></i>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">Word Count</span>
            <span>{document.wordCount || 0}</span>
          </div>

          {document.estimatedReadTime > 0 && (
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-muted small">Read Time</span>
              <span>{document.estimatedReadTime} min</span>
            </div>
          )}
        </div>

        {document.visibilityScope && document.visibilityScope.length > 0 && (
          <div className="mb-3">
            <small className="text-muted d-block mb-1">Visibility:</small>
            <div>
              {document.visibilityScope.map((scope) => (
                <span key={scope} className="badge bg-light text-dark me-1 mb-1">
                  {scope}
                </span>
              ))}
            </div>
          </div>
        )}

        {document.agreementTriggers && document.agreementTriggers.length > 0 && (
          <div className="mb-3">
            <small className="text-muted d-block mb-1">Agreement Triggers:</small>
            <div>
              {document.agreementTriggers.slice(0, 2).map((trigger) => (
                <span key={trigger} className="badge bg-info me-1 mb-1">
                  {trigger.replace(/_/g, " ")}
                </span>
              ))}
              {document.agreementTriggers.length > 2 && (
                <span className="badge bg-secondary">+{document.agreementTriggers.length - 2} more</span>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="card-footer">
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            <i className="fas fa-calendar me-1"></i>
            {formatDate(document.effectiveFrom || document.createdAt)}
          </small>
          <small className="text-muted">by {document.createdBy?.name || "Unknown"}</small>
        </div>
      </div>
    </div>
  )
}

export default LegalDocumentCard